import React, { useState } from "react";

export function ShareWidgetModal({ isOpen, onClose, script, t, onSend }) {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const trimmed = email.trim();
    if (!trimmed) {
      setError(t("Please enter recipient email"));
      return;
    }

    // Простая валидация email: есть @, точка после @ и символы после точки
    const emailPattern = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
    if (!emailPattern.test(trimmed)) {
      setError(t("Please enter a valid email address"));
      return;
    }

    try {
      setSending(true);
      await onSend(trimmed, script);
      setSending(false);
      setEmail("");
      onClose();
    } catch (err) {
      console.error("Error sending share email", err);
      setSending(false);
      setError(t("Failed to send email. Please try again."));
    }
  };

  const trimmed = email.trim();
  const emailPattern = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
  const isValidEmail = emailPattern.test(trimmed);

  return (
    <div className="modal-backdrop">
      <div className="modal">
        <h3>{t("Share widget installation instructions")}</h3>
        <p style={{ marginBottom: 12, fontSize: 14, color: "#555" }}>
          {t(
            "Enter the email of the person who will install the widget. They will receive a short instruction with the script."
          )}
        </p>
        <p style={{ marginBottom: 16, fontSize: 12, color: "#777" }}>
          {t("Ask the recipient to check the Spam or Promotions folder if they don't see the email in the inbox.")}
        </p>
        <form onSubmit={handleSubmit}>
          <label className="field-title">
            <strong>{t("Recipient email")}</strong>
          </label>
          <input
            type="email"
            className="form-input"
            placeholder="admin@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          {error && (
            <div
              style={{
                marginTop: 8,
                color: "#dc3545",
                fontSize: 13,
              }}
            >
              {error}
            </div>
          )}
          <div
            className="agent-form-buttons"
            style={{ marginTop: 16, justifyContent: "flex-end" }}
          >
            <button
              type="button"
              onClick={onClose}
              disabled={sending}
              style={{ marginRight: 8 }}
            >
              {t("Cancel")}
            </button>
            <button
              type="submit"
              disabled={sending || !isValidEmail}
              style={{
                opacity: sending || !isValidEmail ? 0.6 : 1,
                cursor: sending || !isValidEmail ? "not-allowed" : "pointer",
                backgroundColor: sending || !isValidEmail ? "#adb5bd" : "#667eea",
                color: "#ffffff",
                border: "none",
              }}
            >
              {sending ? t("Sending...") : t("Send")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

